import Service from "../../services"

const Common = {
    namespaced: true,
    state: {
        organization: null,
        order: [],
        status: null,
        pagination: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        SET_ORGANIZATION: (state, organization) => {
            state.organization = organization;
        },
        SET_ORDER: (state, res) => {
            state.order = res;
            state.pagination = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                next_page_url: res.next_page_url,
                per_page: res.per_page,
                total: res.total,
                to: res.to,
            };
        },
        CLEAR_ORDER: state => {
            state.pagination = {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            }
        },
    },
    actions: {
        getOrganization({commit}) {
            return Service.Common.getOrganization().then(data => {
                    commit("SET_ORGANIZATION", data);
                    return data;
                })
        },
        getOrganizationAll({commit}) {
            return Service.Common.getOrganizationAll().then(data => {
                    commit("SET_ORGANIZATION", data);
                    return data;
                })
        },
        getOrderAll({commit}, data) {
            // console.log(data)
            return Service.Common.getOrderAll(data.page,data.user_id).then(data => {
                // console.log('res', data)
                commit("SET_ORDER", data);
                return data;
            })
        },
        getOrder({commit}, id) {
            return Service.Common.getOrder(id).then(data => {
                return data;
            })
        },
        updateStatusOrder({commit}, data) {
            return Service.Common.updateStatusOrder(data).then(data => {

                // console.log(data)
                return data;
            })
                // .catch(err => Promise.reject(err))
        },
        saveOrder({commit}, data) {
            return Service.Common.saveOrder(data).then(data => {
                return data;
            }).catch(err => Promise.reject(err))
        },
        saveViewOrder({commit}, data) {
            return Service.Common.saveViewOrder(data).then(data => {
                return data;
            }).catch(err => Promise.reject(err))
        },
        clearOrder({commit}) {
            commit("CLEAR_ORDER");
        },
        getManual() {
            return Service.Common.getManual();
        },
        getQuestion() {
            return Service.Common.getQuestion();
        },
        getYear() {
            return Service.Common.getYears();
        },
    }
}

export default Common
